module.exports = __webpack_public_path__ + "fonts/419a308d-b777-4f84-9235-2caf4a98ec23.872fba3.ttf";